module.exports = __webpack_public_path__ + "img/pitch-deck.4d2a1c7f.svg";